import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section id="cta" className="cta-section">
      <div className="cta-inner">
        <div className="cta-eyebrow">Connect With Apex DeFi Labs</div>

        <h2>Ready to Build the <em>Future Together?</em></h2>

        <p>
          Whether you are an investor evaluating our portfolio, a broker-dealer exploring integration, or a business stakeholder looking to partner — we welcome the conversation.
        </p>

        <div className="cta-actions">
          <Link to="/investor-relations" className="btn-gold" style={{ fontSize: 16, padding: '20px 42px' }}>
            Investor Relations →
          </Link>
          <Link to="/contact" className="btn-ghost-dark" style={{ fontSize: 16, padding: '20px 34px' }}>
            Partner with VYASA
          </Link>
        </div>
      </div>
    </section>
  );
}
